var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._g({class:["mpx-root-view","host-_4a3b28eb"]},_vm.$listeners),[_c('cube-button',{attrs:{"light":""}},[_vm._v("明亮按钮")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }